import { PropTypes } from 'prop-types';
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import { downloadFileFromS3 } from '@/component/common/FileUploaded';
import Utils from '@/common/utils/utils';

function EmailOtherAttachment({ file, detailTicket, setIsShowPopupLogout }) {
    if (!file) return null;

    let tempFile = { type: 1, ...file };

    return (
        <li>
            <a
                className="file-upload-name--change file-upload-active"
                target="_blank"
                onClick={e => {
                    e.preventDefault();
                    downloadFileFromS3(tempFile, detailTicket, false, false, '', setIsShowPopupLogout);
                }}
                href="!#"
            >
                <OverFlowTooltip
                    value={`${file.fileName}(${Utils.formatBytes(file.fileSize)})`}
                    className={'link-file-name'}
                ></OverFlowTooltip>
            </a>
        </li>
    );
}

EmailOtherAttachment.propTypes = {
    file: PropTypes.any,
    detailTicket: PropTypes.any,
    setIsShowPopupLogout: PropTypes.func
};

export default EmailOtherAttachment;

